<template>
  <div>
    <el-row class="title-bar">
      <el-col class="btn-group-right">
        <el-button size="small" @click="exportFileDownload" :disabled="disabledButtonFlag">다운로드</el-button>
        <el-button size="small" @click="onBackupBtnClick" :disabled="disabledButtonFlag">백업</el-button>
        <el-button size="small" @click="onSyncBtnClick" :disabled="disabledButtonFlag">동기화</el-button>
        <el-button size="small" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
        <w-header-search-button @click="showSearchTool = !showSearchTool"/>
      </el-col>
    </el-row>
    <el-row>
      <el-table-wrapper @selection-change="handleSelectionChange" ref="configInfoTable" border :data="tableData" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
        <template slot="changed-slot" slot-scope="scope">
          <span class="link" v-if="scope.row.changed === '1'" @click="showChangeHistPopup(scope.column.property, scope.row)">변경있음</span>
          <span v-else-if="scope.row.changed === '0'">변경없음</span>
          <span v-else> - </span>
        </template>
        <template slot="running-status-slot" slot-scope="scope">
          <span class="state-abnormal" v-if="scope.row.runningStatus === '0'">실패</span>
          <span v-else-if="scope.row.runningStatus === '1'">성공</span>
          <span v-else>실행</span>
        </template>
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-change-hist-popup ref="changeHistPopup" :popup-hist-info="popupHistInfo" />
  </div>
</template>

<script>
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import FileApi from '@/api/common/file';
import { mapGetters } from 'vuex';
import { isNil, isEmpty, map } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import WChangeHistPopup from './popup/ChangeHistPopup';

const runningStatusFilters = [{ text: '성공', value: '1' }, { text: '실패', value: '0' }];
const changedFilters = [{ text: '변경있음', value: '1' }, { text: '변경없음', value: '0' }];
const conflictSrFilters = [{ text: '동기화', value: '1' }, { text: '비동기화', value: '0' }];

export default {
  name: 'WDeviceConfigInfoView',
  components: {
    WChangeHistPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      multipleSelection: [],
      columnDefault,
      tableTotal: 0,
      tableData: [],
      showSearchTool: false,
      columns: [
        { type: 'selection' },
        { prop: 'objName', remoteProp: 'O.obj_name', label: '장비명', scopedSlot: 'obj-name-slot', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddressApplytype', remoteProp: 'ipaddress', label: 'IP', sortable: true, searchable: true, formatter: this.ipaddressFormatter },
        { prop: 'objtypeName', label: '장비종류', remoteProp: 'ot.objtype_name', sortable: true, searchable: true, width: 120, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objCompanyName', remoteProp: 'OC.obj_company_name', label: '제조사', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objProductId', remoteProp: 'O.obj_product_id', label: '모델명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'changed', remoteProp: 'CS.changed', label: '컨피그 변경 여부', sortable: true, filterMultiple: false, scopedSlot: 'changed-slot', filters: changedFilters },
        { prop: 'checkDatetime', remoteProp: 'CS.check_datetime', label: '컨피그 변경 시각', sortable: true, searchable: true, searchType: 'date', formatter: this.convertDatetime },
        { prop: 'recentCheckDatetime', remoteProp: 'nch.check_datetime', label: '수행시각', sortable: true, searchable: true, searchType: 'date', formatter: this.convertDatetime },
        { prop: 'runningStatus', remoteProp: 'BH.running_status', label: '백업상태', sortable: true, scopedSlot: 'running-status-slot', filterMultiple: false, filters: runningStatusFilters, columnKey: 'eventlevelId' },
        { prop: 'conflictSr', remoteProp: 'BH.conflict_sr', label: '컨피그 동기화', sortable: true, filterMultiple: false, formatter: this.conflictSrFormatter, filters: conflictSrFilters },
      ],
      params: {
        managegroupIds: null,
      },
      popupHistInfo: {},
    };
  },
  computed: {
    ...mapGetters(['selectedObjDefineIds', 'selectedNode', 'selectedObjDefineIdsForPhysical']),
    disabledButtonFlag() {
      return isEmpty(this.multipleSelection);
    },
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.params.managegroupIds = this.selectedNode.childManagegroupIds;
        if (this.$refs.configInfoTable === undefined) {
          this.$nextTick(() => {
            this.$refs.configInfoTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.configInfoTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      immediate: true,
    },
    selectedObjDefineIdsForPhysical() {
      this.loadStore();
    },
    /**
     * [activeTab 구성정보 탭 안에서 탭 선택시 store load 처리]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    activeTab: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
  },
  methods: {
    /**
     * [loadStore 그룹>컨피그 정보 리스트 가져오기]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadStore() {
      if (this.active && this.activeTab === this.$options.name) {
        const tableParams = this.$refs.configInfoTable.getParameter();
        const params = {
          ...this.params,
          ...tableParams,
          treeType: this.treeType,
          managetypeId: this.selectedNode.managetypeId,
          objCompanyId: this.selectedNode.objCompanyId,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
        }
        if (!isEmpty(this.selectedObjDefineIds)) {
          params.objDefineIds = this.selectedObjDefineIds;
        }
        netdeviceInfoAPI
          .getNetdeviceConfigInfoList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableData = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [convertDatetime 테이블 날짜 포맷 설정]
     * @author {Yang}
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * [ipaddressFormatter ip포맷터]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    ipaddressFormatter(row) {
      if (isNil(row.ipaddressApplytype)) {
        return EMPTY_TEXT;
      } else if (row.ipaddressApplytype === 'IPv4') {
        return isNil(row.ipaddressIpv4) ? EMPTY_TEXT : row.ipaddressIpv4;
      }
      return isNil(row.ipaddressIpv6) ? EMPTY_TEXT : row.ipaddressIpv6;
    },
    /**
     * [conflictSrFormatter 컨피그 동기화 포멧터]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    conflictSrFormatter(row) {
      if (row.conflictSr === '1') {
        return '동기화';
      }
      return '비동기화';
    },
    /**
     * [exportExcel 엑셀출력] - 필터링된 데이터만 엑셀출력 가능하도록 수정
     * @author {Yang -> NaJY}
     * @return {[type]} [description]
     */
    exportExcel() {
      const tableParams = this.$refs.configInfoTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...this.params,
        ...tableParams,
        treeType: this.treeType,
        managetypeId: this.selectedNode.managetypeId,
        objCompanyId: this.selectedNode.objCompanyId,
      };
      if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
        params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
      }
      if (!isEmpty(this.selectedObjDefineIds)) {
        params.objDefineIds = this.selectedObjDefineIds;
      }
      netdeviceInfoAPI.exportNetdeviceConfigInfoList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    /**
     * [handleSelectionChange 체크박스 클릭시 저장]
     * @author {Yang}
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSelectionChange(row) {
      this.multipleSelection = row;
    },
    /**
     * [exportFileDownload 다운로드 버튼]
     * @author {Yang}
     * @return {[type]} [description]
     */
    exportFileDownload() {
      /* 파일 저장 */
      netdeviceInfoAPI.getNetdeviceConfigInfoDownloadFileName(this.multipleSelection)
        .then((result) => {
          if (result.data.success === true) {
            /* 파일 열기 */
            netdeviceInfoAPI.getNetdeviceConfigInfoFileDownload(result.data.data);
          }
        });
    },
    /**
     * [onBackupBtnClick 백업처리]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onBackupBtnClick() {
      this.$confirm(...msgUtil.getCustomConfirmData('백업을 수행하시겠습니까?')).then(() => {
        const objIds = map(this.multipleSelection, 'objId');
        netdeviceInfoAPI
          .executeNetdeviceConfigInfoBackup(objIds)
          .then((result) => {
            if (result.data.success) {
              this.$refs.configInfoTable.$children[0].clearSelection();
              this.notification('컨피그 백업');
            } else {
              this.$message(msgUtil.getResultMsgData('수행', '컨피그 백업', false));
            }
          });
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData('수행', '컨피그 백업', false));
      });
    },
    /**
     * [onSyncBtnClick 동기화 처리]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onSyncBtnClick() {
      this.$confirm(...msgUtil.getCustomConfirmData('컨피그 동기화를 수행하시겠습니까?')).then(() => {
        const objIds = map(this.multipleSelection, 'objId');
        netdeviceInfoAPI
          .executeNetdeviceConfigInfoSync(objIds)
          .then((result) => {
            if (result.data.success) {
              this.$refs.configInfoTable.$children[0].clearSelection();
              this.notification('컨피그 동기화');
            } else {
              this.$message(msgUtil.getResultMsgData('수행', '컨피그 동기화', false));
            }
          });
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData('수행', '컨피그 동기화', false));
      });
    },
    /**
     * 컨피그 변경 여부 (유) 일때 열리는 팝업
     * @author Yang
     * TODO 컨피그 변경 팝업창에 넘기는 파라미터 확인후 수정 필요
     * @param  {[type]} popupType 클릭한 컬럼의 타입 (device, interface, hardware 등)
     * @param  {[type]} rowData   해당 Row의 Data
     */
    showChangeHistPopup(popupType, rowData) {
      const checkDatetime = new Date(rowData.recentCheckDatetime);

      const popupInfo = {
        popupTitle: '컨피그',
        key: 'CONFIG', /* 쿼리에 사용하지 않음 / 이 값에 따라 불러오는 쿼리가 변경됩니다. 확정 후 수정 필요 */
        objId: rowData.objId,
        configSeq: rowData.configSeq,
        checkDatetime,
      };

      this.$refs.changeHistPopup.open(); // 변경 팝업
      this.popupHistInfo = popupInfo;
    },
    onChangeTable() {
      this.loadStore();
    },
    /**
     * [notification 수행완료 notify]
     * @author {Yang}
     * @param  {[type]} title [description]
     * @return {[type]}       [description]
     */
    notification(title) {
      this.$notify({
        title: `${title} 수행`,
        customClass: 'center',
        message: `${title}를 수행하였습니다.`,
        duration: 2000,
      });
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/DeviceConfigInfoView.vue